import { useEffect, useState } from 'react';

/**
 * This hook allows you to detect clicks outside of a specified element.
 * Quelle: https://usehooks.com/useOnClickOutside/
 * @param {*} ref Reference
 * @param {*} handler Callback
 */
function useOnClickOutside(ref, handler) {
    useEffect(
        () => {
            const listener = event => {
                // Do nothing if clicking ref's element or descendent elements
                if (!ref.current || ref.current.contains(event.target)) {
                    return;
                }

                handler(event);
            }

            document.addEventListener('mousedown', listener);
            document.addEventListener('touchstart', listener);

            return () => {
                document.removeEventListener('mousedown', listener);
                document.removeEventListener('touchstart', listener);
            }
        },
        // Add ref and handler to effect dependencies
        // It's worth noting that because passed in handler is a new ...
        // ... function on every render that will cause this effect ...
        // ... callback/cleanup to run every render. It's not a big deal ...
        // ... but to optimize you can wrap handler in useCallback before ...
        // ... passing it into this hook.
        [ref, handler]
    );
}

/* Quelle: https://omerduraker.medium.com/dark-and-light-mode-using-react-tailwind-css-58bb8f988080 */
function useDarkMode() {
    const [theme, setTheme] = useState(localStorage.theme);
    const colorTheme = theme === 'dark' ? 'light' : 'dark';

    useEffect(() => {
      const root = window.document.documentElement;
      root.classList.remove(colorTheme);
      root.classList.add(theme);
      
      // Save theme to Local Storage
      localStorage.setItem('theme', theme);
      
      // fire event
      const event = new Event('onThemeChanged');
      event.value = theme;
      event.key = 'theme';
      document.dispatchEvent(event);

    }, [theme, colorTheme]);
    
    // console.log('return colorTheme: ' + colorTheme)
    return [colorTheme, setTheme];
}

export { useOnClickOutside, useDarkMode };